import { type CommunityCode } from './communities';
import { type ImageSource } from 'expo-image';

interface SocialTagEntry {
  icon: ImageSource;
  color: string;
}

const socialTagIcons: Partial<Record<CommunityCode, Record<string, SocialTagEntry>>> = {
  grommr: {
    Admirer: { icon: require('@/assets/socialtags/grommr/Admirer.png'), color: '#f5b95f' },
    Bloater: { icon: require('@/assets/socialtags/grommr/Bloater.png'), color: '#649bae' },
    Encourager: { icon: require('@/assets/socialtags/grommr/Encourager.png'), color: '#8fb066' },
    Gainer: { icon: require('@/assets/socialtags/grommr/Gainer.png'), color: '#83745c' },
    Maintainer: { icon: require('@/assets/socialtags/grommr/Maintainer.png'), color: '#dd8745' },
    MuscleGainer: { icon: require('@/assets/socialtags/grommr/MuscleGainer.png'), color: '#a8605e' },
  },
  feabie: {
    BBW: { icon: require('@/assets/socialtags/feabie/BBW.png'), color: '#e49443' },
    BHM: { icon: require('@/assets/socialtags/feabie/BHM.png'), color: '#a9987e' },
    FA: { icon: require('@/assets/socialtags/feabie/FA.png'), color: '#4d91a4' },
    Feedee: { icon: require('@/assets/socialtags/feabie/Feedee.png'), color: '#e45c43' },
    Feeder: { icon: require('@/assets/socialtags/feabie/Feeder.png'), color: '#31a759' },
  },
  chasabl: {
    Bear: { icon: require('@/assets/socialtags/chasabl/Bear.png'), color: '#e0ad15' },
    Chaser: { icon: require('@/assets/socialtags/chasabl/Chaser.png'), color: '#82a659' },
    Chub: { icon: require('@/assets/socialtags/chasabl/Chub.png'), color: '#705f5c' },
    Chub4Chub: { icon: require('@/assets/socialtags/chasabl/Chub4Chub.png'), color: '#de4f3f' },
    ChubbyBear: { icon: require('@/assets/socialtags/chasabl/ChubbyBear.png'), color: '#e08529' },
    Cub: { icon: require('@/assets/socialtags/chasabl/Cub.png'), color: '#2194ba' },
  },
  ferzu: {
    Amphibian: { icon: require('@/assets/socialtags/ferzu/Amphibian.png'), color: '#12e440' },
    Aquatic: { icon: require('@/assets/socialtags/ferzu/Aquatic.png'), color: '#03aece' },
    Avian: { icon: require('@/assets/socialtags/ferzu/Avian.png'), color: '#ff5341' },
    BearSpecie: { icon: require('@/assets/socialtags/ferzu/BearSpecie.png'), color: '#df6d00' },
    Bovid: { icon: require('@/assets/socialtags/ferzu/Bovid.png'), color: '#ffb000' },
    Canid: { icon: require('@/assets/socialtags/ferzu/Canid.png'), color: '#ffd26f' },
    Cervid: { icon: require('@/assets/socialtags/ferzu/Cervid.png'), color: '#8B6738' },
    Dragon: { icon: require('@/assets/socialtags/ferzu/Dragon.png'), color: '#008b1f' },
    Exotic: { icon: require('@/assets/socialtags/ferzu/Exotic.png'), color: '#00a825' },
    FelineLarge: { icon: require('@/assets/socialtags/ferzu/FelineLarge.png'), color: '#ffb614' },
    FelineSmall: { icon: require('@/assets/socialtags/ferzu/FelineSmall.png'), color: '#d08238' },
    Fox: { icon: require('@/assets/socialtags/ferzu/Fox.png'), color: '#ff7c00' },
    Horse: { icon: require('@/assets/socialtags/ferzu/Horse.png'), color: '#a06f00' },
    Hybrid: { icon: require('@/assets/socialtags/ferzu/Hybrid.png'), color: '#9730f1' },
    Marsupial: { icon: require('@/assets/socialtags/ferzu/Marsupial.png'), color: '#df9900' },
    OtherMammal: { icon: require('@/assets/socialtags/ferzu/OtherMammal.png'), color: '#ed1600' },
    OtherSpecie: { icon: require('@/assets/socialtags/ferzu/OtherSpecie.png'), color: '#35c1db' },
    Otter: { icon: require('@/assets/socialtags/ferzu/Otter.png'), color: '#5e4f2c' },
    Panda: { icon: require('@/assets/socialtags/ferzu/Panda.png'), color: '#000000' },
    Primate: { icon: require('@/assets/socialtags/ferzu/Primate.png'), color: '#5e442c' },
    Rabbit: { icon: require('@/assets/socialtags/ferzu/Rabbit.png'), color: '#dd8076' },
    Raccoon: { icon: require('@/assets/socialtags/ferzu/Raccoon.png'), color: '#016c80' },
    Reptilian: { icon: require('@/assets/socialtags/ferzu/Reptilian.png'), color: '#00a825' },
    Rodent: { icon: require('@/assets/socialtags/ferzu/Rodent.png'), color: '#777980' },
    Skunk: { icon: require('@/assets/socialtags/ferzu/Skunk.png'), color: '#51b19b' },
    Wolf: { icon: require('@/assets/socialtags/ferzu/Wolf.png'), color: '#4a4d58' },
  },
  pupspace: {
    Alpha: { icon: require('@/assets/socialtags/pupspace/Alpha.png'), color: '#0582ca' },
    Beta: { icon: require('@/assets/socialtags/pupspace/Beta.png'), color: '#74b2d5' },
    Boy: { icon: require('@/assets/socialtags/pupspace/Boy.png'), color: '#9c9c9c' },
    Bull: { icon: require('@/assets/socialtags/pupspace/Bull.png'), color: '#42b8b2' },
    CatKitten: { icon: require('@/assets/socialtags/pupspace/CatKitten.png'), color: '#42b8b2' },
    Daddy: { icon: require('@/assets/socialtags/pupspace/Daddy.png'), color: '#593e2c' },
    Dog: { icon: require('@/assets/socialtags/pupspace/Dog.png'), color: '#29292b' },
    Dominant: { icon: require('@/assets/socialtags/pupspace/Dominant.png'), color: '#ee1b26' },
    Fox: { icon: require('@/assets/socialtags/pupspace/Fox.png'), color: '#42b8b2' },
    FriendOfPups: { icon: require('@/assets/socialtags/pupspace/FriendOfPups.png'), color: '#0582ca' },
    HandlerTrainer: { icon: require('@/assets/socialtags/pupspace/HandlerTrainer.png'), color: '#0582ca' },
    HorsePony: { icon: require('@/assets/socialtags/pupspace/HorsePony.png'), color: '#42b8b2' },
    Master: { icon: require('@/assets/socialtags/pupspace/Master.png'), color: '#29292b' },
    Mommy: { icon: require('@/assets/socialtags/pupspace/Mommy.png'), color: '#593e2c' },
    Omega: { icon: require('@/assets/socialtags/pupspace/Omega.png'), color: '#74b2d5' },
    PetOther: { icon: require('@/assets/socialtags/pupspace/PetOther.png'), color: '#42b8b2' },
    Pup: { icon: require('@/assets/socialtags/pupspace/Pup.png'), color: '#0582ca' },
    Sir: { icon: require('@/assets/socialtags/pupspace/Sir.png'), color: '#29292b' },
    Slave: { icon: require('@/assets/socialtags/pupspace/Slave.png'), color: '#9c9c9c' },
    Submissive: { icon: require('@/assets/socialtags/pupspace/Submissive.png'), color: '#fc9ea4' },
    Switch: { icon: require('@/assets/socialtags/pupspace/Switch.png'), color: '#fc9ea4' },
    Wolf: { icon: require('@/assets/socialtags/pupspace/Wolf.png'), color: '#42b8b2' },
  },
};

export function getSocialTagIcon(community: CommunityCode | undefined, tagName: string): ImageSource | undefined {
  if (!community) return undefined;
  return socialTagIcons[community]?.[tagName]?.icon;
}

export function getSocialTagColor(community: CommunityCode | undefined, tagName: string): string | undefined {
  if (!community) return undefined;
  return socialTagIcons[community]?.[tagName]?.color;
}

/**
 * Returns white or a darkened version of the background color for text,
 * based on WCAG relative luminance of the background.
 */
export function getContrastTextColor(hexColor: string): string {
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;

  const toLinear = (c: number) => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
  const luminance = 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);

  const toHex = (c: number) => Math.min(255, Math.max(0, Math.round(c))).toString(16).padStart(2, '0');

  if (luminance <= 0.5) {
    const lighten = (c: number) => c * 255 + (255 - c * 255) * 0.95;
    return `#${toHex(lighten(r))}${toHex(lighten(g))}${toHex(lighten(b))}`;
  }

  const darken = (c: number) => c * 255 * 0.40;
  return `#${toHex(darken(r))}${toHex(darken(g))}${toHex(darken(b))}`;
}
